export const borderStyle = {
  solid: "solid",
  dashed: "dashed",
};
